import API from "./api";

const TestService = {
  // ============ ADMIN FUNCTIONS ============

  // Categories
  getCategories: async () => {
    try {
      const response = await API.get("/admin/tests/categories");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createCategory: async (data) => {
    try {
      const response = await API.post("/admin/tests/categories", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCategory: async (id, data) => {
    try {
      const response = await API.put(`/admin/tests/categories/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteCategory: async (id) => {
    try {
      const response = await API.delete(`/admin/tests/categories/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Questions
  getQuestions: async (categoryId, page = 1, limit = 20, search = "") => {
    try {
      let url = `/admin/tests/questions/${categoryId}?page=${page}&limit=${limit}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getQuestionCount: async (categoryId) => {
    try {
      const response = await API.get(
        `/admin/tests/questions/count/${categoryId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create question
  createQuestion: async (data) => {
    try {
      console.log("Creating question with data:", data);
      const response = await API.post("/admin/tests/questions", data);
      console.log("Create question response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error creating question:", error);
      console.error("Error response:", error.response?.data);
      throw error;
    }
  },

  updateQuestion: async (id, data) => {
    try {
      const response = await API.put(`/admin/tests/questions/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteQuestion: async (id) => {
    try {
      const response = await API.delete(`/admin/tests/questions/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tests
  getTests: async (page = 1, limit = 20, search = "") => {
    try {
      let url = `/admin/tests?page=${page}&limit=${limit}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTest: async (id) => {
    try {
      const response = await API.get(`/admin/tests/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createTest: async (data) => {
    try {
      const response = await API.post("/admin/tests", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateTest: async (id, data) => {
    try {
      const response = await API.put(`/admin/tests/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Update test error:", error);
      throw error;
    }
  },

  deleteTest: async (id) => {
    try {
      const response = await API.delete(`/admin/tests/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateTestStatus: async (id, status) => {
    try {
      const response = await API.post(`/admin/tests/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTestResults: async (testId) => {
    try {
      const response = await API.get(`/admin/tests/results/${testId}`);
      return response.data;
    } catch (error) {
      console.error("Get test results error:", error);
      throw error;
    }
  },

  // Get student attempt details for admin
  getAdminAttemptDetails: async (attemptId) => {
    try {
      const response = await API.get(`/admin/tests/attempt/${attemptId}`);
      return response.data;
    } catch (error) {
      console.error("Get admin attempt details error:", error);
      throw error;
    }
  },

  // ============ STUDENT FUNCTIONS ============

  getMyTests: async (page = 1, limit = 10) => {
    try {
      const response = await API.get(`/tests/my?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  startTest: async (testId) => {
    try {
      const response = await API.post(`/tests/start/${testId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  saveAnswer: async (attemptId, answers) => {
    try {
      const response = await API.post(`/tests/attempt/${attemptId}/save`, {
        answers,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  submitTest: async (attemptId, answers) => {
    try {
      console.log("Submitting test - Attempt ID:", attemptId);
      console.log("Submitting test - Answers:", answers);

      const response = await API.post(`/tests/attempt/${attemptId}/submit`, {
        answers,
      });

      console.log("Submit response:", response);

      return response.data;
    } catch (error) {
      console.error("Submit test error:", error);
      console.error("Error response:", error.response);
      console.error("Error data:", error.response?.data);
      throw error;
    }
  },

  // Get test progress with remaining time (updated)
  getTestProgress: async (attemptId) => {
    try {
      const response = await API.get(`/tests/attempt/${attemptId}/progress`);
      return response.data;
    } catch (error) {
      console.error("Error fetching test progress:", error);
      throw error;
    }
  },

  getResult: async (attemptId) => {
    try {
      const response = await API.get(`/tests/result/${attemptId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add to TestService object

  // Import questions from another category
  importQuestions: async (data) => {
    try {
      console.log("Importing questions with data:", data);
      const response = await API.post("/admin/tests/questions/import", data);
      console.log("Import response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error importing questions:", error);
      console.error("Error response:", error.response?.data);
      throw error;
    }
  },

  // Get students for test assignment
  getTestStudents: async (testId) => {
    try {
      const response = await API.get(`/admin/tests/${testId}/students`);
      return response.data;
    } catch (error) {
      console.error("Error fetching test students:", error);
      throw error;
    }
  },
  // Assign test to specific students
  assignTestToStudents: async (testId, studentIds, maxAttempts = 1) => {
    try {
      const response = await API.post(
        `/admin/tests/${testId}/assign-students`,
        {
          student_ids: studentIds,
          max_attempts: maxAttempts,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error assigning test to students:", error);
      throw error;
    }
  },

  // Remove student assignment
  removeStudentAssignment: async (testId, studentId) => {
    try {
      const response = await API.delete(
        `/admin/tests/${testId}/students/${studentId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error removing student assignment:", error);
      throw error;
    }
  },

  // Get student attempt count
  getStudentAttemptCount: async (studentId, testId) => {
    try {
      const response = await API.get(
        `/admin/students/${studentId}/test/${testId}/attempts`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching attempt count:", error);
      throw error;
    }
  },

};

export default TestService;
